<div class="app-text-chat-box bc-panel">
  <div *ngIf="textChat.TextChatID" class="text-chat-panel">
    <div class="bc-text-chat-content">
      <div class="bc-content-inner column-flex-container" *ngIf="!isTransferPanelActive">
        <div class="scroll-bottom-list panel-body text-chat-messages column-flex-grow" [ngClass]="{ 'bc-text-chat-inactive': !isTextChatActive() }">
          <app-visitor-history class="bc-panel"
                              *ngIf="!isExpandedMode()"
                              [textChatId]="textChat.TextChatID"
                              (loaded)="onVisitorHistoryLoaded()"></app-visitor-history>

          <app-chat-messages [messages]="messages"
                         [isActive]="isTextChatActive()"
                         [workItemId]="textChat.TextChatID"
                         [workItemCreated]="textChat.Created"
                         [workItemType]="workItem.type"></app-chat-messages>

          <app-loading *ngIf="areWrapupsLoading()"></app-loading>

          <app-wrap-up-panel *ngIf="haveWrapupsLoaded() && !hideWrapUpPanel"
                           [workItemId]="textChat.TextChatID"
                           [isEnded]="textChat.isEnded()"
                           [isClosed]="textChat.isClosed()"
                           [type]="workItem.type"
                           [rawWrapups]="wrapups"
                           (wrapUpChange)="onWrapUpChange($event)"
                           (togglePanel)="toggleWrapupPanel()"></app-wrap-up-panel>
        </div>

        <app-text-chat-actions class="column-flex-fix"
                              [messages]="messages"
                              [isInProgress]="isInProgress()"
                              [isAnswerable]="isAnswerable()"
                              [isUserTyping]="isUserTyping()"
                              (answerTextChat)="answerTextChat()"
                              [visitorName]="textChat.ChatName"
                              *ngIf="isTextChatActive()"></app-text-chat-actions>

        <app-auto-save [model]="message" [storageKey]="'text-chat-' + textChat.TextChatID" *ngIf="isTextChatActive()"></app-auto-save>

        <div class="column-flex-fix" *ngIf="isInProgress() && isFocused()" class="send-message-control">

          <app-file-upload-box [workItemId]="workItem.id"></app-file-upload-box>

          <app-alert-box [editorMessages]="editorMessages.messages" (closeHandler)="clearEditorMessage()"></app-alert-box>

          <div class="text-chat-panel-footer row no-margin work-widget-panel-footer">

            <a *ngIf="!isExpandedMode() && !isMoreActionsVisible"
               (click)="toggleCannedMessagePanel()"
               class="btn btn-borderless btn-cm"
               data-automation-id="text-chat-canned-message-btn">
              <svg-icon icon="can-outline"></svg-icon>
            </a>

            <app-editor #editorComponent *ngIf="!isMoreActionsVisible || isExpandedMode()"
                        [workItemId]="workItem.id"
                        [workItemType]="workItem.type"
                        [editorMessages]="editorMessages"
                        [commandList]="editorCommandList"
                        [editorInitSetting]="editorInitSetting"
                        [(editorContentModel)]="message.text"
                        (editorSetupDone)="onEditorSetupDone($event)"
                        [cannedMessageRequest]="cannedMessageRequest"
                        (onEditorSubmit)="onEditorSubmit($event)"
                        [submitOnEnter]="true"
                        (onCommandSelected)="executeCommand($event)"
                        [editorDisabled]="editorDisabled"
                        [showFileUpload]="isFileTransferForOperatorEnabled$ | async"
                        [isAccessibilitySettingAvailable]="true"></app-editor>

            <text-chat-buttons
              *ngIf="isExpandedMode()"
              [hasWrapUps]="hasWrapUps()"
              (transfer)="openTransferTextChatSettings()"
              [isEndable]="isEndable()"
              (end)="endOrShowConfirmation()"
              (wrapup)="toggleWrapupPanel()"></text-chat-buttons>
          </div>

          <div class="text-chat-more-actions more-actions" *ngIf="!isExpandedMode()" [ngClass]="{ 'open': isMoreActionsVisible }">
            <svg-icon icon="ellipsis" class="more-actions-icon" (click)="toggleMoreActions()" *ngIf="!isMoreActionsVisible"></svg-icon>

            <text-chat-more-actions
              *ngIf="isMoreActionsVisible"
              [hasWrapUps]="hasWrapUps()"
              (transfer)="openTransferTextChatSettings()"
              (end)="endOrShowConfirmation()"
              (toggle)="toggleMoreActions()"
              (wrapup)="toggleWrapupPanel()"></text-chat-more-actions>
          </div>

          <app-smart-responses
            *ngIf="hasSmartResponseFeature"
            [isSmartResponsesActive]="isSmartResponsesActive"
            (smartResponseSelected)="smartResponseSelected($event)"
            (setFocusOnEditor)="setFocusOnEditor()"
            (smartResponsesClosed)="closeSmartResponsePanel()"
            [record]="textChat"></app-smart-responses>
        </div>

      </div>
      <div class="bc-content-inner" *ngIf="isTransferPanelActive && isTextChatActive()">
        <app-transfer-panel (backButtonAction)="closeTransferChatSettings()"
                           [workItemId]="workItem.id"
                           [workItemType]="workItem.type"></app-transfer-panel>
      </div>
      <app-confirmation-modal
        *ngIf="!isConfirmationModalDisabled() && confirmationVisible"
        (cancel)="closeConfirmation()"
        (confirm)="endTextChat()"
        (secondaryAction)="endTextChatAndDontShowModal()"
        [config]="confirmationBoxConfig"></app-confirmation-modal>
    </div>
  </div>
</div>
<div class="inactive-text-chat-panel-footer" *ngIf="!isFocused()">
  <app-inactive-widget-footer [text]="message.text"></app-inactive-widget-footer>
</div>
